import ProductSection from "./ProductSections";
import CardCarousel from "./CardCarousel";
import DifferentialsSection from "./DifferentialsSection";
import WhoWeAreSection from "./WhoWeAreSection";
import ProjectsSection from "./ProjectsSection";
import TestimonialsSection from "./TestimonialsSection";

const Home = () => {
  return (
    <div>
      <ProductSection />
      <CardCarousel />
      <DifferentialsSection />
      <WhoWeAreSection />
      <ProjectsSection />
      <TestimonialsSection />
    </div>
  );
};

export default Home;
